import { AxiosResponse } from 'axios';

export const responseHandler = <T>(res: AxiosResponse<T>): T => res.data;
